import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getGithubActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({github}: BackupState) => github.actions);
export const getGithubActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({github}: BackupState) => github.totalActions);
export const isGithubActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({github}: BackupState) => github.loading);
export const getGithubCanRestore = createSelector((state: DefaultRootState) => state.backups, ({github}: BackupState) => github.canRestore);
